import { Layout } from "antd";
import { useSelector } from "react-redux";
import ExceptionPage from "../../pages/ExceptionPage";
import Router from "../../scenes/Router";
import { RootState } from "../../store/store";
import Drawer from "./Drawer";

const { Content } = Layout;
const ContentComponent = () => {
  const resourceState = useSelector((state: RootState) => state.resources);

  if (resourceState.resources.error.status)
    return <ExceptionPage status={resourceState.resources.error.status} />;

  return (
    <div className="site-drawer-render-in-current-wrapper">
      <Content>
        <Router />
        <Drawer />
      </Content>
    </div>
  );
};
export default ContentComponent;
